var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-bottom": "10px" } },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("collectionCenter.GeneratePickupCode")) +
                  " "
              ),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "collectionFormRef",
              attrs: {
                size: "small",
                "label-position": "top",
                model: _vm.collectionForm,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.belongDot"),
                            prop: "siteId",
                            rules: {
                              required: true,
                              message: _vm.$t("collectionCenter.pleaseChoose"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getSiteOption,
                              },
                              on: {
                                "visible-change": _vm.getSiteOptionVisible,
                              },
                              model: {
                                value: _vm.collectionForm.siteId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.collectionForm, "siteId", $$v)
                                },
                                expression: "collectionForm.siteId",
                              },
                            },
                            _vm._l(_vm.siteAllList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("GlobalSetObj.nextStation") + ":",
                            prop: "nextStationId",
                            rules: {
                              required: true,
                              message: _vm.$t("GlobalSetObj.pleaseChoose"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getSiteOption,
                              },
                              on: {
                                "visible-change": _vm.getSiteOptionVisible,
                                change: function ($event) {
                                  return _vm.changeNextSite()
                                },
                              },
                              model: {
                                value: _vm.collectionForm.nextStationId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.collectionForm,
                                    "nextStationId",
                                    $$v
                                  )
                                },
                                expression: "collectionForm.nextStationId",
                              },
                            },
                            _vm._l(_vm.siteAllList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.printQ"),
                            prop: "printCount",
                            rules: {
                              required: true,
                              validator: _vm.checkPrintNum,
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.PleaseEnterNumberBetween1And99"
                              ),
                            },
                            model: {
                              value: _vm.collectionForm.printCount,
                              callback: function ($$v) {
                                _vm.$set(_vm.collectionForm, "printCount", $$v)
                              },
                              expression: "collectionForm.printCount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-top": "28px" },
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleSubmit },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("collectionCenter.generate")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            { attrs: { size: "small", "label-position": "top" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.PickupCode"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.pleaseInput"
                              ),
                            },
                            model: {
                              value: _vm.queryForm.params.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm.params, "code", $$v)
                              },
                              expression: "queryForm.params.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.belongD") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getSiteOption,
                              },
                              on: {
                                "visible-change": _vm.getSiteOptionVisible,
                              },
                              model: {
                                value: _vm.queryForm.params.siteId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "siteId", $$v)
                                },
                                expression: "queryForm.params.siteId",
                              },
                            },
                            _vm._l(_vm.siteAllList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("GlobalSetObj.nextStation") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getSiteOption,
                              },
                              on: {
                                "visible-change": _vm.getSiteOptionVisible,
                              },
                              model: {
                                value: _vm.queryForm.params.nextStationId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "nextStationId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.nextStationId",
                              },
                            },
                            _vm._l(_vm.siteAllList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.CreationTime"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "picker-options": _vm.pickerOptions,
                              clearable: true,
                              "default-time": ["00:00:00", "23:59:59"],
                              format:
                                _vm.$i18n.locale === "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              placeholder: _vm.$t("newOrder.SelectDatetime"),
                              "range-separator": "~",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.timeArr,
                              callback: function ($$v) {
                                _vm.timeArr = $$v
                              },
                              expression: "timeArr",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "28px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.handleQuery },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("collectionCenter.search")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.onReset },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("collectionCenter.reset")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content:
                                _vm.expandQuery === false
                                  ? _vm.$t("orderCenterCont.ExpandQuery")
                                  : _vm.$t("orderCenterCont.CollapseQuery"),
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.onExpandQuery },
                              },
                              [
                                _vm.expandQuery === false
                                  ? _c("i", {
                                      staticClass: "el-icon-d-arrow-right",
                                      staticStyle: {
                                        transform: "rotate(90deg)",
                                      },
                                    })
                                  : _c("i", {
                                      staticClass: "el-icon-d-arrow-right",
                                      staticStyle: {
                                        transform: "rotate(-90deg)",
                                      },
                                    }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm.expandQuery
                ? _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.stateZT"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "collectionCenter.pleaseChoose"
                                        ),
                                        clearable: "",
                                        filterable: "",
                                      },
                                      model: {
                                        value: _vm.queryForm.params.status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "status",
                                            $$v
                                          )
                                        },
                                        expression: "queryForm.params.status",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        key: "0",
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.tudo"
                                          ),
                                          value: null,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "1",
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.NotBound"
                                          ),
                                          value: 0,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "2",
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.Bound"
                                          ),
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "3",
                                        attrs: {
                                          label: _vm.$t(
                                            "GlobalSetObj.Carregado"
                                          ),
                                          value: 2,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.handlePrint(2, null)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("collectionCenter.Print")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.exportNumber()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.export")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": { background: "#ebebeb", color: "#000" },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "50",
                  align: "center",
                  fixed: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.ind"),
                  align: "center",
                  width: "60px",
                  fixed: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.PickupCode"),
                  prop: "code",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.belongD"),
                  prop: "siteName",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.nextStation"),
                  prop: "nextStationName",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.CreationTime"),
                  prop: "createTime",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.creator"),
                  prop: "createUserName",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.stateZT"),
                  "min-width": "160",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 0
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("collectionCenter.NotBound")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        scope.row.status === 1
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("collectionCenter.Bound")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        scope.row.status === 2
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("GlobalSetObj.Carregado")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.BoundBags"),
                  prop: "boundBagCount",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.BoundPackages"),
                  prop: "boundPackageCount",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label:
                    _vm.$t("collectionCenter.TotalInvoiceAmount") + "(BRL)",
                  prop: "totalInvoiceAmount",
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.totalInvoiceAmount)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operation"),
                  "min-width": "180",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status !== 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlePrint(1, scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("collectionCenter.Print")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        scope.row.status !== 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("collectionCenter.detail")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { margin: "10px 0", float: "right" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("collectionCenter.Print") + " PDF",
            visible: _vm.showPrintWindow,
            width: "580px",
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "3%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showPrintWindow = $event
            },
          },
        },
        [
          _c("printWindow", {
            key: _vm.printWindowKey,
            ref: "printWindowRef",
            attrs: { "print-data": _vm.printData },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handlePrintConfirm },
                },
                [_vm._v(" " + _vm._s(_vm.$t("collectionCenter.Print")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showPrintWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title:
              _vm.$t("collectionCenter.PickupCode") + " - " + _vm.rowData.code,
            visible: _vm.showDetailWindow,
            direction: "ltr",
            "append-to-body": true,
            "close-on-press-escape": false,
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetailWindow = $event
            },
          },
        },
        [
          _c("detailWindow", {
            key: _vm.detailWindowKey,
            attrs: { "row-data": _vm.rowData },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }